const getContentEditableCaretPosition = (element) => {
  if (!element) {
    return 0;
  }

  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) {
    return 0;
  }

  const range = selection.getRangeAt(0);
  let container = range.startContainer;
  let isWithinElement = false;

  while (container) {
    if (container === element) {
      isWithinElement = true;
      break;
    }
    container = container.parentNode;
  }

  if (!isWithinElement) {
    return 0;
  }

  const preCaretRange = range.cloneRange();
  preCaretRange.selectNodeContents(element);
  preCaretRange.setEnd(range.endContainer, range.endOffset);

  const text = preCaretRange.toString();

  return text.length;
};

export default getContentEditableCaretPosition;
